import { StatusLabel } from '@shared/components/StatusLabel';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle.hook';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import { useFolder } from '../api/folders.api';
import type { TRootItems } from '../types/folders.types';
import AllProductsContent from '../components/AllProductsContent';

const AllProducts = () => {
  const { data, error } = useFolder();

  useDocumentTitle(`All ${TERMINOLOGY.product.lowerPlural}`);

  return (
    <StatusLabel
      data={data}
      loadingMessage={`Loading ${TERMINOLOGY.product.lowerPlural}...`}
      error={error}
      errorMessage={`Loading ${TERMINOLOGY.product.lowerPlural} failed!`}
      render={(rootItems) => <AllProductsContent data={rootItems as TRootItems} />}
    />
  );
};

export default AllProducts;
